export default "__VITE_ASSET__BlZe2Tre__"